import { SelectOption } from "@/shared/types/SelectOption";
import { EllipsisOutlined } from "@ant-design/icons";
import { Col, Divider, List, Row, Typography } from "antd";

const DADOS_SYNC_AUTOMATICO: SelectOption[] = [
  {
    label: "Servidores",
    value: "servidores",
  },
  {
    label: "Programações",
    value: "programacoes",
  },
  {
    label: "Produtos Autorizados",
    value: "produtos_autorizados",
  },
  {
    label: "Marcas de Produtos",
    value: "marcas_de_produtos",
  },
  {
    label: "Ensaios Anáises",
    value: "ensaios_analises",
  },
  {
    label: "Estabelecimentos",
    value: "estabelecimentos",
  },
  {
    label: "Motivos de Notificação",
    value: "motivos_notificacao",
  },
  {
    label: "Formulários de Perguntas",
    value: "formularios",
  },
  {
    label: "Laboratórios de Análise",
    value: "laboratorios_analise",
  },
];

export function DadosSyncAutomatico() {
  return (
    <>
      <Divider>
        <Typography.Title level={5}>
          Sincronizados Automaticamente
        </Typography.Title>
      </Divider>

      <Row align="middle" justify="center">
        <Col span={24}>
          <List
            size="small"
            dataSource={DADOS_SYNC_AUTOMATICO}
            bordered
            renderItem={(item) => (
              <List.Item key={item.value}>
                <List.Item.Meta
                  avatar={<EllipsisOutlined />}
                  title={item.label}
                  style={{ opacity: 0.7 }}
                />
              </List.Item>
            )}
          />
        </Col>
      </Row>
    </>
  );
}
